module.exports = __webpack_public_path__ + "static/media/SA.80c90956.svg";